import React, { useRef } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

function AssigneEmployeeToCase({
  departmentOptions,
  employeeOptions,
  handleDepartmentAssign1,
  handleCheckboxChangeAssign,
  customStyles,
  dropdownRef,
}) {
  return (
    <div className="row row-sm-1 mt-4">
      <strong className="" style={{ fontSize: "16px" }}>
        Employee Assignment (Optional)
      </strong>
      <div className="col-md-12 mt-2">
        <div className="row">
          {/* Department Select */}
          <div className="col-md-6">
            <label className="form-label" style={{ fontSize: "12px" }}>
              Department
            </label>
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              onChange={handleDepartmentAssign1}
              styles={customStyles}
              isMulti
              options={departmentOptions}
            />
          </div>

          {/* Employee Select */}
          <div className="col-md-6" ref={dropdownRef}>
            <label className="form-label" style={{ fontSize: "12px" }}>
              Employee:
            </label>
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              onChange={handleCheckboxChangeAssign}
              styles={customStyles}
              isMulti
              options={employeeOptions}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssigneEmployeeToCase;
